import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
interface ToastProps {
  message: string;
  isVisible: boolean;
  onClose: () => void;
  duration?: number;
}
export function Toast({
  message,
  isVisible,
  onClose,
  duration = 3000
}: ToastProps) {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);
  return <AnimatePresence data-id="element-3993">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      type: 'spring',
      duration: 0.5,
      bounce: 0.3
    }} className="fixed bottom-6 right-6 z-[9999] flex items-center gap-3 bg-emerald-600 text-white px-6 py-4 rounded-lg shadow-2xl max-w-md" data-id="element-3994">
          <CheckCircle2 size={24} className="flex-shrink-0" data-id="element-3995" />
          <p className="font-medium flex-1" data-id="element-3996">{message}</p>
          <button onClick={onClose} className="flex-shrink-0 p-1 hover:bg-emerald-700 rounded transition-colors" data-id="element-3997">
            <X size={18} data-id="element-3998" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}